<script lang="ts">
	//Components
	import ModalPrompt from 'src/components/ModalPrompt.svelte';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Design system components
	import { Button, Icon, Text, toast } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { get_local_ip, real_id } from 'src/helpers/interface_helpers';

	export let device;

	let showModal = false;
	let loading = false;
	const id = real_id(device.id);

	const erase_data = async () => {
		let res: SettingRequest;
		const localIp = get_local_ip(id);
		console.warn('localIp', localIp);
		loading = true;
		if (localIp) {
			res = await localReq(device, `${localIp}/reset_data`, 'post', {}, 20000, true);
		} else {
			res = await postReq(`/device/erase_data?id=${id}`, {
				id,
			});
		}
		if (res.isok) {
			toast.open({
				type: 'success',
				title: $format('erase_data_scc_toast') || `Device's data was erased successfully!`,
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
		loading = false;
	};

	const props = {
		title: `${$format('erase_dev_data_title', {
			default: 'Erase Device Data',
		})}?`,
		buttons: [$format('button_no'), $format('button_yes')],
		callback: erase_data,
		button_1_variant: 'danger',
		button_1: $format('erase_data_button', { default: 'Erase data' }),
		button_2: $format('button_cancel'),
	};

	const openModal = () => {
		showModal = true;
	};
</script>

<Text styleType="body-small">
	{$format('erase_data_description')}
</Text>
{#if showModal}
	<ModalPrompt bind:showModal {props}>
		<div class="d-flex flex-direction-column align-items-center mb-xs">
			<Icon icon="text-danger fa-light fa-trash" size="xxl" />
			<Text class="width-full">
				{$format('delete_statistical_en_data_msg', {
					default:
						'This will permanently delete all statistical energy data stored on the device.',
				})}
			</Text>
		</div>
	</ModalPrompt>
{/if}
<Button variant="danger" class="mt-s" size="m" width="full" {loading} on:click={openModal}
	>{$format('sub_settings_title_erase_data')}</Button
>
